import { useQuery } from 'react-query';
import axios from 'axios';

const apiUrl = () => process.env.REACT_APP_BASIX_API || '';

// item 1591 (Linda: "label the Ultrasonic subscriptions like they used to be"; Chad: "the $ name
// easily and the friendly name next to each other … without having to click on anything") —
// what each Stripe subscription carries on ITSELF (its description + its invoice footer), keyed
// by subscription id, for the ledgers' "(SOFTWARE_ID · friendly name)" tag (subscriptionUnit).
// One request for the whole tenant BESIDE a ledger's own index (never inside it), cached 10 min;
// a failure (Stripe down, not admin/accountant) is simply "no tags" — a ledger never waits on it.
export interface StripeSubscriptionIdentity {
  subscriptionId: string;
  description?: string | null;
  footer?: string | null;
}
export type StripeSubscriptionIdentityMap = Record<string, StripeSubscriptionIdentity>;

const EMPTY: StripeSubscriptionIdentityMap = {};

export default function useStripeSubscriptionIdentities(): StripeSubscriptionIdentityMap {
  const { data } = useQuery<StripeSubscriptionIdentityMap>(
    'stripeSubscriptionIdentities',
    async () => {
      try {
        const { data: body } = await axios.get(`${apiUrl()}payment/subscription-identities`);
        const map: StripeSubscriptionIdentityMap = {};
        ((body?.items ?? []) as StripeSubscriptionIdentity[]).forEach((i) => {
          if (i?.subscriptionId) map[i.subscriptionId] = i;
        });
        return map;
      } catch {
        return {};
      }
    },
    { staleTime: 10 * 60 * 1000, retry: false, refetchOnWindowFocus: false },
  );
  return data ?? EMPTY;
}
